import { createSlice } from "@reduxjs/toolkit";

const initialCalcState = {
  selectedNote: { noteId: "", noteTitle: "", noteText: "" },
  backdrop: false,
  filterType: "",
  filterInput: "",
};

const noteSlice = createSlice({
  name: "note",
  initialState: initialCalcState,
  reducers: {
    setSelectedNote(state, action) {
      // console.log(action.payload)
      state.selectedNote.noteId = action.payload.noteId;
      state.selectedNote.noteTitle = action.payload.noteTitle;
      state.selectedNote.noteText = action.payload.noteText;
    },
    setBackdrop(state, action) {
      state.backdrop = action.payload;
    },
    setFilterType(state, action) {
      state.filterType = action.payload.filterType
    },
    inputFilterSetter(state, action) {
      state.filterInput = action.payload.filterInput
    },
  },
});

export const noteActions = noteSlice.actions;

export default noteSlice;
